import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { PaymentSuccessOverlay } from './core/components/payment-success-overlay/payment-success-overlay';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PaymentSuccessOverlay],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
